$(document).ready(function() {
  // Select each <li> element and add custom classes
  $(".grid__item").each(function(index) {
    $(this).addClass("custom-" + (index + 1));
  });
});
jQuery( document ).ready(function() {
   jQuery('.btn').click(function () {
        jQuery(this).toggleClass("click");
        jQuery('.custom-main-menu-wrapper').toggleClass("show");
         jQuery('.main_side li').toggleClass("animate__fadeInLeft");
    });
    jQuery('.sidebar ul li a').click(function () {
        var id = jQuery(this).attr('id');
        jQuery('nav ul li ul.item-show-' + id).toggleClass("show");
        jQuery('nav ul li #' + id + ' span').toggleClass("rotate");

    });

    jQuery('nav ul li').click(function () {
        jQuery(this).addClass("active").siblings().removeClass("active");
    });

  
});

jQuery(document).ready(function($) {
      $('.sleep-logos').slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: true,
          centerMode: true,
        focusOnSelect: true,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
             centerMode: false,
           }
        }]
    });

var close_button = document.getElementById('closeAnnounce');
close_button.onclick = CloseData;
  
function CloseData(){
  Cookies.set('announcement','yes');
   document.getElementById("shopify-section-announcement-bar").style.display = 'none';
}
var x = Cookies.get('announcement');
if (x) {
}
   else
  {
    jQuery('.announcement-bar').removeClass('hidden-announce');
  }
  
  jQuery(".features-btn a").click(function() {
    jQuery('html, body').animate({
        scrollTop: $(".product-information-main-wrapper").offset().top
    }, 1000);
});
  jQuery(".features-btn a").click(function() {
    jQuery('html, body').animate({
      //scrollTop: eval($('#' + $(this).attr('target')).offset().top - 70)
        scrollTop: jQuery(".product-information-main-wrapper").offset().top-110
    }, 400);
    
});
});

jQuery(document).ready(function () {
    jQuery(window).on("resize", function (e) {
      var newWindowWidth = jQuery(window).width();

       if (newWindowWidth < 767) {
        jQuery(this).parent().toggleClass("active");
              // alert('Hello')
        jQuery(this).next('ul.footer-block__details-content').slideToggle(500);
      }  
    });
  jQuery('h2.footer-block__heading').click(function() {
    var newWindowWidth = jQuery(window).width();
     if (newWindowWidth < 767) {
        jQuery(this).parent().toggleClass("active");
              // alert('Hello')
        jQuery(this).next('ul.footer-block__details-content').slideToggle(500);
      }  
  });

    
});
